import { render, staticRenderFns } from "./BannerCopy.vue?vue&type=template&id=6e53ed20&"
import script from "./BannerCopy.vue?vue&type=script&lang=js&"
export * from "./BannerCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports